import { Component, OnInit } from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Component({
	templateUrl: "./unauthorized.component.html",
	styleUrls: ["./unauthorized.component.scss"],
})
export class UnauthorizedComponent {
	constructor(private _cookie: CookieService) {}
	get studentDashboardUrl() {
		return this._cookie.get(`sop_dashboard_url`) || "https://students.ischoolconnect.com/auth";
	}
}
